import { useQuery, useQueryClient } from 'react-query'
import APIService from 'api/APIService'
import { useSettings } from './useSettings'
import { JobStatus } from 'types/entity'
import useNotifications from './useNotifications'
import useLocalStorage from './useLocalStorage'

const useImportTeamPlaces = () => {
  const {
    data: { pollingJobs },
    set
  } = useSettings()
  const notification = useNotifications()
  const queryClient = useQueryClient()
  const [localJobId, setJobId] = useLocalStorage(
    'team_places_import_token_id',
    ''
  )

  const jobID = pollingJobs.importTeamPlacesJobId || localJobId

  useQuery(
    ['import-team-places-polling', jobID],
    () =>
      APIService.misc.getJobStatus({
        jobId: jobID
      }),
    {
      enabled: !!jobID,
      refetchInterval: 2000,
      onSuccess: (response: JobStatus) => {
        if (response.status === 'finished') {
          notification.dismiss('importTeamPlacesJobId')
          setJobId('')
          set('pollingJobs', {
            ...pollingJobs,
            importTeamPlacesJobId: ''
          })
          notification.success({
            title: 'Team places have been imported',
            id: jobID,
            duration: 1000
          })
          queryClient.invalidateQueries(['team', 'places'])
        }

        if (response.status === 'failed') {
          notification.dismiss('importTeamPlacesJobId')
          notification.error({
            title: 'There were some errors with your file',
            subtitle: response.error_list?.[0] ?? 'Something went wrong',
            id: jobID
          })
          setJobId('')
          set('pollingJobs', {
            ...pollingJobs,
            importTeamPlacesJobId: ''
          })
        }
      },
      onError: () => {
        notification.dismiss('importTeamPlacesJobId')
        notification.error({
          title: 'Could not import some team places',
          id: jobID
        })
        setJobId('')
        set('pollingJobs', {
          ...pollingJobs,
          importTeamPlacesJobId: ''
        })
      }
    }
  )

  return null
}

export default useImportTeamPlaces
